import { Alert, Button, Spin } from 'antd'
import { useAuthSession } from '@/lib/session'
import FeatureThemeProvider from '@/components/FeatureThemeProvider'
import { useCapacitySettings } from './hooks'
import { SetupPage } from './setup/page'
import { DashboardPage } from './dashboard/page'

export function CapacityPlannerPage() {
  const session = useAuthSession()
  const clientId = session?.currentClientId ?? ''
  const { data: settings, isLoading, isError, refetch } = useCapacitySettings(clientId)

  if (isLoading) {
    return (
      <FeatureThemeProvider featureKey="pracPlanner" withAntd className="flex justify-center p-12">
        <Spin size="large" />
      </FeatureThemeProvider>
    )
  }

  if (isError) {
    return (
      <FeatureThemeProvider featureKey="pracPlanner" withAntd className="p-6">
        <Alert
          type="error"
          message="Failed to load PracPlanner settings"
          action={<Button size="small" onClick={() => refetch()}>Retry</Button>}
        />
      </FeatureThemeProvider>
    )
  }

  if (!settings) {
    return <SetupPage onComplete={async () => {
      await refetch()
    }} />
  }

  return <DashboardPage settings={settings} />
}
